import * as api from '../../api/api-modal-contacto-tercero';
import { 
    GET_CONFIG_FORM15,
    GET_COMBO_MODO_CONTACTO_MODAL,
    GET_COMBO_RESPUESTA_CONTACTO_MODAL,
    GET_GRILLA_HISTORIAL,
    POST_ACTUALIZAR_CONTACTO,
    GET_DATOS_ULTIMOCONTACTO,
    SET_MODO_CONTACTO,
    SET_LOADING,
    SET_MODO
    
} from '../types';

export const configuracionFormAction15 = (query) => ({
    type: GET_CONFIG_FORM15,
    payload: api.getConfiguracionForm15(query)
});
export const obtenerModo= (modo) => ({
    type: SET_MODO,
    payload: modo
});
export const obtenerComboModoContactoModal = (query) => ({
    type: GET_COMBO_MODO_CONTACTO_MODAL,
    payload: api.getComboModoContacto(query)
});
export const obtenerComboRespuestaContactoModal = (query) => ({
    type: GET_COMBO_RESPUESTA_CONTACTO_MODAL,
    payload: api.getComboRespuestaContacto(query)
});
export const obtenerGrillaHistorial = (query) => ({
    type: GET_GRILLA_HISTORIAL,
    payload: api.getGrillaHistorialModal(query)
});
export const postActualizarContactoAction = (newContacto) => ({
    type: POST_ACTUALIZAR_CONTACTO,
    payload: api.postActualizarContacto(newContacto)
});
export const obtenerDatosUltimoContacto = (query) => ({
    type: GET_DATOS_ULTIMOCONTACTO,
    payload: api.getDatosUltimoContacto(query)
});
export const cambiarModoContacto = (isModo) => ({
    type: SET_MODO_CONTACTO,
    payload: isModo
});
export const cambiarLoading = (loading) => ({
    type: SET_LOADING,
    payload: loading
});